import { trackEvent, trackNonInteractionEvent } from "@leafly-com/web-utils";

export type GtmEvent = {
  eventLabel: string;
  eventCategory: string;
  eventAction?: EventAction;
  dimensions?: Dimensions;
};
export type GtmEventPartial = Partial<GtmEvent>;

export type FinalGtmEvent = {
  eventLabel: string;
  eventCategory: string;
  eventAction: EventAction;
} & Dimensions;

type DimensionKeys =
  | "brandId"
  | "brandName"
  | "dealId"
  | "dispensaryId"
  | "fullUrl"
  | "menuItemId"
  | "productCategoryId"
  | "productId"
  | "productName"
  | "strainId"
  | "strainName"
  | "trayNumber"
  | "userId";

export type Dimensions = { [dimension in DimensionKeys]?: string | number };

export enum EventAction {
  click = "click",
  impression = "impression",
}

function isFinalGtmlEvent(
  gtmEvent: FinalGtmEvent | GtmEventPartial,
): gtmEvent is FinalGtmEvent {
  return (
    (gtmEvent as FinalGtmEvent).eventLabel !== undefined &&
    (gtmEvent as FinalGtmEvent).eventCategory !== undefined &&
    (gtmEvent as FinalGtmEvent).eventAction !== undefined
  );
}

const trackGtmEvent = (
  defaultEvent: GtmEventPartial,
  eventOverrides?: GtmEventPartial,
): void => {
  const event = { ...defaultEvent, ...eventOverrides };
  if (isFinalGtmlEvent(event)) {
    const { eventCategory, eventAction, eventLabel, ...dimensions } = event;
    const track =
      event.eventAction === EventAction.impression
        ? trackNonInteractionEvent
        : trackEvent;

    track(eventCategory, eventAction, eventLabel, dimensions);
  }
};

export default trackGtmEvent;
